import { LandingPage } from "@icoach/landingPage/";
import { CLUB_HOME_ROUTER, CLUB_EMPLOYEE_SCHEDULE_ROUTER, CLUB_APPOINTMENT_ROUTER } from "@icoach/router/routerPath";
import { LANDING_NAVIGATION_TABS } from "@icoach/constants/";

// 首頁
const landingPageRouter = [
	{
		description: "首頁",
		frontKey: "C1X01",
	},
	{
		description: "來店會員",
		exact: true,
		path: CLUB_HOME_ROUTER.TABS_PAGE,
		href: CLUB_HOME_ROUTER.ARRIVE,
		as: LandingPage,
		frontKey: "C1X02",
	},
	{
		description: "預約表",
		exact: true,
		path: CLUB_APPOINTMENT_ROUTER.TABS_PAGR,
		href: CLUB_APPOINTMENT_ROUTER.GET_TABS_PATH(LANDING_NAVIGATION_TABS.TIME_SCHEDULING),
		as: LandingPage,
		frontKey: "C1X03",
	},
	{
		description: "每日班表",
		exact: true,
		path: CLUB_EMPLOYEE_SCHEDULE_ROUTER.TABS_PAGE,
		href: CLUB_EMPLOYEE_SCHEDULE_ROUTER.SHIFT_SCHEDULING,
		as: LandingPage,
		frontKey: "C1X04",
	},
	{
		description: "預約管理",
		exact: true,
		path: CLUB_APPOINTMENT_ROUTER.TABS_PAGR,
		href: CLUB_APPOINTMENT_ROUTER.GET_TABS_PATH(LANDING_NAVIGATION_TABS.OVERVIEW),
		as: LandingPage,
		frontKey: "C1X05",
	},
];

export default landingPageRouter;
